import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { cn } from "../lib/utils";

export function ThemeToggle({ className, size = "md" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const sizes = { sm: "h-8 w-8", md: "h-9 w-9", lg: "h-10 w-10" };

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      className={cn(
        "rounded-lg flex items-center justify-center border transition-all",
        "border-transparent text-zinc-400 hover:text-white hover:bg-white/5 hover:border-white/10",
        "light:text-zinc-600 light:hover:text-[#1A1A1A] light:hover:bg-black/5 light:hover:border-black/10",
        sizes[size],
        className,
      )}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
